export enum StorageKeyEnum {
  ALL_META_TAG_LIST_DATA_KEY = 'ALL_META_TAG_LIST_DATA_KEY',
  COMIC_NAME_LIST_DATA_KEY = 'COMIC_NAME_LIST_DATA_KEY'
}
